import { render, staticRenderFns } from "./onvego.vue?vue&type=template&id=1070dddb"
import script from "./onvego.vue?vue&type=script&lang=js"
export * from "./onvego.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports